<template>
  <div
    class="flex flex-col px-10 py-6 rounded gap-y-6 min-w-full min-h-72 lg:min-w-[25%] grow lg:shrink-0 xl:shrink lg:basis-[calc(50%-1rem)] xl:basis-[calc(33.3%-1rem)]"
    :class="classes"
  >
    <div class="flex justify-between">
      <NuxtLink v-if="titleLink" to="/">
        <CHeading :level="3" class="cursor-pointer">{{ title }}</CHeading>
      </NuxtLink>
      <CHeading v-else :level="3">{{ title }}</CHeading>

      <CLink
        v-if="card.fields.seeAllLink"
        class="self-center whitespace-nowrap"
        :variant="linkVariant"
        :to="
          card.fields.seeAllLink.fields.isExternalLink
            ? `https://${card.fields.seeAllLink.fields.url}`
            : card.fields.seeAllLink.fields.url
        "
        :use-visited="false"
      >
        {{ card.fields.seeAllLink.fields.text }}
      </CLink>
    </div>
    <div class="flex flex-col gap-y-3">
      <CLink
        v-for="(linkEntry, index) in links"
        :key="index"
        :variant="linkVariant"
        :to="linkEntry.fields.isExternalLink ? `https://${linkEntry.fields}` : linkEntry.fields.url"
        :use-visited="false"
      >
        <span class="flex items-center gap-x-3">
          <ContentfulImage v-if="linkEntry.fields.icon" :entry="linkEntry.fields.icon" />
          {{ linkEntry.fields.text }}
        </span>
      </CLink>
    </div>
  </div>
</template>

<script setup lang="ts">
type Link = {
  fields: {
    icon: any;
    text: string;
    isExternalLink: boolean;
    url: string;
  };
};

type ServiceCard = {
  metadata: any;
  sys: any;
  fields: {
    links: Link[];
    title: string;
    titleLink: string;
    seeAllLink: Link;
  };
};

type Props = {
  backgroundColor?: string;
  card: ServiceCard;
};

const props = withDefaults(defineProps<Props>(), {
  backgroundColor: 'primary',
});

const bgColor = computed(() => {
  switch (props.backgroundColor) {
    case 'primary':
      return 'bg-primary-900';
    case 'white':
      return 'bg-white';
    case 'beige':
      return 'bg-beige-500';
    default:
      return null;
  }
});

const textColor = computed(() => (props.backgroundColor === 'primary' ? 'text-white' : 'text-black'));
const classes = computed(() => `${bgColor.value} ${textColor.value}`);
const titleLink = computed(() => props.card.fields.titleLink);
const title = computed(() => props.card.fields.title);
const links = computed(() => props.card.fields.links);
const linkVariant = computed(() => (props.backgroundColor === 'primary' ? 'light' : 'dark'));
</script>

<script lang="ts">
export default defineComponent({
  name: 'ServiceCard',
});
</script>
